import { render, staticRenderFns } from "./Oct7th.vue?vue&type=template&id=98a54014&scoped=true&"
import script from "./Oct7th.vue?vue&type=script&lang=js&"
export * from "./Oct7th.vue?vue&type=script&lang=js&"
import style0 from "./Oct7th.vue?vue&type=style&index=0&id=98a54014&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a54014",
  null
  
)

export default component.exports